import { ImprovementActivity } from '@models/mips-stepper.model';

export const IA_ACTIVITIES_2025: ImprovementActivity[] = [
  // Expanded Practice Access
  {
    activityId: 'IA_EPA_2',
    activityDescription: 'Use of telehealth services that expand practice access',
    category: 'Expanded Practice Access',
    subcategory: 'Expanded Practice Access',
    weight: 'medium',
    points: 20,
    supportingInfo: 'Create and implement a standardized process for providing telehealth services to expand access to care.',
    selected: false,
  },
  {
    activityId: 'IA_EPA_3',
    activityDescription: 'Collection and use of patient experience and satisfaction data on access',
    category: 'Expanded Practice Access',
    subcategory: 'Expanded Practice Access',
    weight: 'medium',
    points: 20,
    supportingInfo: 'Collection of patient experience and satisfaction data on access to care and development of an improvement plan, such as outlining steps for improving communications with patients to help understanding of urgent access needs.',
    selected: false,
  },
  {
    activityId: 'IA_EPA_4',
    activityDescription: 'Additional improvements in access as a result of QIN/QIO TA',
    category: 'Expanded Practice Access',
    subcategory: 'Expanded Practice Access',
    weight: 'medium',
    points: 20,
    supportingInfo: 'As a result of Quality Innovation Network-Quality Improvement Organization technical assistance, performance of additional activities that improve access to services or improve care coordination (for example, investment of on-site diabetes educator).',
    selected: false,
  },
  {
    activityId: 'IA_EPA_5',
    activityDescription: 'Participation in User Testing of the Quality Payment Program Website (https://qpp.cms.gov/)',
    category: 'Expanded Practice Access',
    subcategory: 'Expanded Practice Access',
    weight: 'medium',
    points: 20,
    supportingInfo: 'User participation in the Quality Payment Program website testing is an activity for eligible clinicians who have worked with CMS to provide substantive, timely, and responsive input to improve the CMS Quality Payment Program website through product user-testing.',
    selected: false,
  },
  {
    activityId: 'IA_EPA_6',
    activityDescription: 'Create and Implement a Language Access Plan',
    category: 'Expanded Practice Access',
    subcategory: 'Expanded Practice Access',
    weight: 'medium',
    points: 20,
    supportingInfo: 'Create and implement a language access plan to address communication barriers for individuals with limited English proficiency. The language access plan must align with standards for communication and language assistance defined in the National Standards for Culturally and Linguistically Appropriate Services (CLAS) in Health and Health Care.',
    selected: false,
  },

  // Population Management
  {
    activityId: 'IA_PM_2',
    activityDescription: 'Anticoagulant Management Improvements',
    category: 'Population Management',
    subcategory: 'Population Management',
    weight: 'medium',
    points: 20,
    supportingInfo: 'Individual MIPS eligible clinicians and groups who prescribe anti-coagulation medications must attest that for 75 percent of their ambulatory care patients receiving these medications are being managed with support from systematic anticoagulation programs.',
    selected: false,
  },
  {
    activityId: 'IA_PM_3',
    activityDescription: 'RHC, IHS or FQHC quality improvement activities',
    category: 'Population Management',
    subcategory: 'Population Management',
    weight: 'medium',
    points: 20,
    supportingInfo: 'Participating in a Rural Health Clinic (RHC), Indian Health Service Medium Management (IHS), or Federally Qualified Health Center in ongoing engagement activities that contribute to more formal quality reporting.',
    selected: false,
  },
  {
    activityId: 'IA_PM_4',
    activityDescription: 'Glycemic management services',
    category: 'Population Management',
    subcategory: 'Population Management',
    weight: 'medium',
    points: 20,
    supportingInfo: 'For outpatient Medicare beneficiaries with diabetes and who are prescribed antidiabetic agents, must attest to having at least 60 percent of medical records with documentation of an individualized glycemic treatment goal.',
    selected: false,
  },
  {
    activityId: 'IA_PM_5',
    activityDescription: 'Engagement of community for health status improvement',
    category: 'Population Management',
    subcategory: 'Population Management',
    weight: 'medium',
    points: 20,
    supportingInfo: 'Take steps to improve health status of communities, such as collaborating with key partners and stakeholders to implement evidenced-based practices to improve a specific chronic condition.',
    selected: false,
  },
  {
    activityId: 'IA_PM_6',
    activityDescription: 'Population health management (SUSPENDED)',
    category: 'Population Management',
    subcategory: 'Population Management',
    weight: 'medium',
    points: 20,
    supportingInfo: 'This activity has been suspended for the 2025 performance period. However, if this activity has already been completed or was in the process of being completed, you can still attest to completing it and receive credit.',
    selected: false,
    suspended: true,
  },
  {
    activityId: 'IA_PM_11',
    activityDescription: 'Regular review practices in place on targeted patient population needs',
    category: 'Population Management',
    subcategory: 'Population Management',
    weight: 'medium',
    points: 20,
    supportingInfo: 'Implement regular reviews of targeted patient population needs, such as structured clinical case reviews. Reviews should stratify patient data by demographic characteristics and health related social needs.',
    selected: false,
  },
  {
    activityId: 'IA_PM_12',
    activityDescription: 'Population empanelment',
    category: 'Population Management',
    subcategory: 'Population Management',
    weight: 'medium',
    points: 20,
    supportingInfo: 'Empanel (assign responsibility for) the total population, linking each patient to a MIPS eligible clinician or group or care team.',
    selected: false,
  },
  {
    activityId: 'IA_PM_13',
    activityDescription: 'Chronic Care and Preventative Care Management for Empaneled Patients',
    category: 'Population Management',
    subcategory: 'Population Management',
    weight: 'medium',
    points: 20,
    supportingInfo: 'Manage chronic and preventive care for empaneled patients, including providing patients annually with an opportunity for development of an individualized plan of care.',
    selected: false,
  },
  {
    activityId: 'IA_PM_14',
    activityDescription: 'Implementation of methodologies for improvements in longitudinal care management for high risk patients',
    category: 'Population Management',
    subcategory: 'Population Management',
    weight: 'medium',
    points: 20,
    supportingInfo: 'Provide longitudinal care management to patients at high risk for adverse health outcome or harm using consistent methods to assign and adjust global risk status.',
    selected: false,
  },
  {
    activityId: 'IA_PM_15',
    activityDescription: 'Implementation of episodic care management practice improvements',
    category: 'Population Management',
    subcategory: 'Population Management',
    weight: 'medium',
    points: 20,
    supportingInfo: 'Provide episodic care management, including management across transitions and referrals with routine and timely follow-up to hospitalizations, ED visits and stays in other institutional settings.',
    selected: false,
  },
  {
    activityId: 'IA_PM_16',
    activityDescription: 'Implementation of medication management practice improvements',
    category: 'Population Management',
    subcategory: 'Population Management',
    weight: 'medium',
    points: 20,
    isMvpMeasure: true,
    supportingInfo: 'Manage medications to maximize efficiency, effectiveness and safety including reconciling medications across transitions of care and conducting periodic structured medication reviews.',
    selected: false,
  },
  {
    activityId: 'IA_PM_17',
    activityDescription: 'Participation in Population Health Research',
    category: 'Population Management',
    subcategory: 'Population Management',
    weight: 'medium',
    points: 20,
    supportingInfo: 'Participation in federally and/or privately funded research that identifies interventions, tools, or processes that can improve a targeted patient population.',
    selected: false,
  },
  {
    activityId: 'IA_PM_18',
    activityDescription: 'Provide Clinical-Community Linkages',
    category: 'Population Management',
    subcategory: 'Population Management',
    weight: 'medium',
    points: 20,
    supportingInfo: 'Engaging community health workers to provide a comprehensive link to community resources through family-based services focusing on success in health, education, and self-sufficiency.',
    selected: false,
  },
  {
    activityId: 'IA_PM_19',
    activityDescription: 'Glycemic Screening Services',
    category: 'Population Management',
    subcategory: 'Population Management',
    weight: 'medium',
    points: 20,
    supportingInfo: 'For at-risk outpatient Medicare beneficiaries, attest to implementation of systematic preventive approaches in clinical practice for at least 60 percent of electronic medical records with documentation of screening patients for abnormal blood glucose.',
    selected: false,
  },
  {
    activityId: 'IA_PM_20',
    activityDescription: 'Glycemic Referring Services',
    category: 'Population Management',
    subcategory: 'Population Management',
    weight: 'medium',
    points: 20,
    supportingInfo: 'For at-risk outpatient Medicare beneficiaries, attest to implementation of systematic preventive approaches for at least 60 percent of medical records with documentation of referring eligible patients with prediabetes to a CDC-recognized diabetes prevention program.',
    selected: false,
  },
  {
    activityId: 'IA_PM_21',
    activityDescription: 'Advance Care Planning',
    category: 'Population Management',
    subcategory: 'Population Management',
    weight: 'medium',
    points: 20,
    supportingInfo: 'Implementation of practices/processes to develop advance care planning that includes documenting the advance care plan or living will within the medical record.',
    selected: false,
  },
  {
    activityId: 'IA_PM_22',
    activityDescription: 'Improving Practice Capacity for Human Immunodeficiency Virus (HIV) Prevention Services',
    category: 'Population Management',
    subcategory: 'Population Management',
    weight: 'medium',
    points: 20,
    supportingInfo: 'Establish policies and procedures to improve practice capacity to increase HIV prevention screening, improve HIV prevention education and awareness, and reduce disparities in pre-exposure prophylaxis (PrEP) uptake.',
    selected: false,
  },
  {
    activityId: 'IA_PM_23',
    activityDescription: 'Use of Computable Guidelines and Clinical Decision Support to Improve Adherence for Cervical Cancer Screening and Management Guidelines',
    category: 'Population Management',
    subcategory: 'Population Management',
    weight: 'medium',
    points: 20,
    supportingInfo: 'Incorporate the Cervical Cancer Screening and Management (CCSM) Clinical Decision Support (CDS) tool within the electronic health record (EHR) system to provide clinicians with ready access to the most up-to-date clinical practice guidelines.',
    selected: false,
  },
  {
    activityId: 'IA_PM_24',
    activityDescription: 'Implementation of Protocols and Provision of Resources to Increase Lung Cancer Screening Uptake',
    category: 'Population Management',
    subcategory: 'Population Management',
    weight: 'medium',
    points: 20,
    supportingInfo: 'Establish a process or procedure to increase rates of lung cancer screening through implementation of protocols that support enhanced documentation methods to identify eligible patients.',
    selected: false,
  },
  {
    activityId: 'IA_PM_25',
    activityDescription: 'Save a Million Hearts: Standardization of Approach to Screening and Treatment for Cardiovascular Disease Risk',
    category: 'Population Management',
    subcategory: 'Population Management',
    weight: 'medium',
    points: 20,
    supportingInfo: 'Implement standardized, evidence-based cardiovascular disease risk assessment and care management for a defined population in the clinician\'s practice.',
    selected: false,
  },
  {
    activityId: 'IA_PM_26',
    activityDescription: 'Population health improvement (SUSPENDED)',
    category: 'Population Management',
    subcategory: 'Population Management',
    weight: 'medium',
    points: 20,
    isMvpMeasure: true,
    supportingInfo: 'This activity has been suspended for the 2025 performance period. However, if this activity has already been completed or was in the process of being completed, you can still attest to completing it and receive credit.',
    selected: false,
    suspended: true,
  },

  // Care Coordination
  {
    activityId: 'IA_CC_1',
    activityDescription: 'Implementation of Use of Specialist Reports Back to Referring Clinician or Group to Close Referral Loop',
    category: 'Care Coordination',
    subcategory: 'Care Coordination',
    weight: 'medium',
    points: 20,
    isMvpMeasure: true,
    supportingInfo: 'Performance of regular practices that include providing specialist reports back to the referring individual MIPS eligible clinician or group to close the referral loop.',
    selected: false,
  },
  {
    activityId: 'IA_CC_2',
    activityDescription: 'Implementation of improvements that contribute to more timely communication of test results',
    category: 'Care Coordination',
    subcategory: 'Care Coordination',
    weight: 'medium',
    points: 20,
    supportingInfo: 'Timely communication of test results defined as timely identification of abnormal test results with timely follow-up.',
    selected: false,
  },
  {
    activityId: 'IA_CC_7',
    activityDescription: 'Regular training in care coordination',
    category: 'Care Coordination',
    subcategory: 'Care Coordination',
    weight: 'medium',
    points: 20,
    supportingInfo: 'Implementation of regular care coordination training.',
    selected: false,
  },
  {
    activityId: 'IA_CC_8',
    activityDescription: 'Implementation of documentation improvements for practice/process improvements',
    category: 'Care Coordination',
    subcategory: 'Care Coordination',
    weight: 'medium',
    points: 20,
    supportingInfo: 'Implementation of practices/processes that document care coordination activities (e.g., a documented care coordination encounter that tracks all clinical staff involved).',
    selected: false,
  },
  {
    activityId: 'IA_CC_9',
    activityDescription: 'Implementation of practices/processes for developing regular individual care plans',
    category: 'Care Coordination',
    subcategory: 'Care Coordination',
    weight: 'medium',
    points: 20,
    supportingInfo: 'Implementation of practices/processes to develop regularly updated individual care plans for at-risk patients that are shared with the beneficiary or caregiver(s).',
    selected: false,
  },
  {
    activityId: 'IA_CC_10',
    activityDescription: 'Care transition documentation practice improvements',
    category: 'Care Coordination',
    subcategory: 'Care Coordination',
    weight: 'medium',
    points: 20,
    supportingInfo: 'Document practices/processes for care transition with documentation of how a MIPS eligible clinician or group carried out an action plan for the patient during the first 30 days following a discharge.',
    selected: false,
  },
  {
    activityId: 'IA_CC_11',
    activityDescription: 'Care transition standard operational improvements',
    category: 'Care Coordination',
    subcategory: 'Care Coordination',
    weight: 'medium',
    points: 20,
    supportingInfo: 'Establish standard operations to manage transitions of care including establishing formalized lines of communication with local settings.',
    selected: false,
  },
  {
    activityId: 'IA_CC_12',
    activityDescription: 'Care coordination agreements that promote improvements in patient tracking across settings',
    category: 'Care Coordination',
    subcategory: 'Care Coordination',
    weight: 'medium',
    points: 20,
    supportingInfo: 'Establish effective care coordination and active referral management including establishing care coordination agreements with frequently used consultants.',
    selected: false,
  },
  {
    activityId: 'IA_CC_13',
    activityDescription: 'Practice improvements to align with OpenNotes principles',
    category: 'Care Coordination',
    subcategory: 'Care Coordination',
    weight: 'medium',
    points: 20,
    isMvpMeasure: true,
    supportingInfo: 'Adherence to the principles described in the OpenNotes initiative to ensure that patients have full access to their patient information to guide patient care.',
    selected: false,
  },
  {
    activityId: 'IA_CC_15',
    activityDescription: 'PSH Care Coordination',
    category: 'Care Coordination',
    subcategory: 'Care Coordination',
    weight: 'medium',
    points: 20,
    supportingInfo: 'Participation in a Perioperative Surgical Home (PSH) that provides a patient-centered, physician-led, interdisciplinary, and team-based system of coordinated patient care.',
    selected: false,
  },
  {
    activityId: 'IA_CC_16',
    activityDescription: 'Primary Care Physician and Behavioral Health Bilateral Electronic Exchange of Information for Shared Patients',
    category: 'Care Coordination',
    subcategory: 'Care Coordination',
    weight: 'medium',
    points: 20,
    supportingInfo: 'The primary care and behavioral health practices use the same electronic health record system for shared patients or have an established bidirectional flow of records.',
    selected: false,
  },
  {
    activityId: 'IA_CC_17',
    activityDescription: 'Patient Navigator Program',
    category: 'Care Coordination',
    subcategory: 'Care Coordination',
    weight: 'medium',
    points: 20,
    supportingInfo: 'Implement a Patient Navigator Program that offers evidence-based resources and tools to reduce avoidable hospital readmissions.',
    selected: false,
  },
  {
    activityId: 'IA_CC_18',
    activityDescription: 'Relationship-Centered Communication',
    category: 'Care Coordination',
    subcategory: 'Care Coordination',
    weight: 'medium',
    points: 20,
    supportingInfo: 'MIPS eligible clinicians must participate in a minimum of eight hours of training on relationship-centered care tenets.',
    selected: false,
  },
  {
    activityId: 'IA_CC_19',
    activityDescription: 'Tracking of clinician\'s relationship to and responsibility for a patient by reporting MACRA patient relationship codes',
    category: 'Care Coordination',
    subcategory: 'Care Coordination',
    weight: 'medium',
    points: 20,
    supportingInfo: 'Attest that they reported MACRA patient relationship codes (PRC) using the applicable HCPCS modifiers on 50 percent or more of their Medicare claims for a minimum of a continuous 90-day period.',
    selected: false,
  },

  // Beneficiary Engagement
  {
    activityId: 'IA_BE_1',
    activityDescription: 'Use of certified EHR to capture patient reported outcomes',
    category: 'Beneficiary Engagement',
    subcategory: 'Beneficiary Engagement',
    weight: 'medium',
    points: 20,
    supportingInfo: 'Perform activities that enable capture of patient reported outcomes through use of certified electronic health record technology.',
    selected: false,
  },
  {
    activityId: 'IA_BE_3',
    activityDescription: 'Engagement with QIN-QIO to implement self-management training programs',
    category: 'Beneficiary Engagement',
    subcategory: 'Beneficiary Engagement',
    weight: 'medium',
    points: 20,
    supportingInfo: 'Engagement with a Quality Innovation Network-Quality Improvement Organization, which may include participation in self-management training programs such as diabetes.',
    selected: false,
  },
  {
    activityId: 'IA_BE_4',
    activityDescription: 'Engagement of patients through implementation of improvements in patient portal',
    category: 'Beneficiary Engagement',
    subcategory: 'Beneficiary Engagement',
    weight: 'high',
    points: 40,
    isMvpMeasure: true,
    supportingInfo: 'Provide access to an enhanced patient/caregiver portal that allows users to engage in bidirectional information exchange.',
    selected: false,
  },
  {
    activityId: 'IA_BE_5',
    activityDescription: 'Enhancements/regular updates to practice websites/tools that also include considerations for patients with cognitive disabilities',
    category: 'Beneficiary Engagement',
    subcategory: 'Beneficiary Engagement',
    weight: 'medium',
    points: 20,
    supportingInfo: 'Enhancements and ongoing regular updates and use of websites/tools that include consideration for compliance with section 508 of the Rehabilitation Act of 1973.',
    selected: false,
  },
  {
    activityId: 'IA_BE_6',
    activityDescription: 'Regularly Assess Patient Experience of Care and Follow Up on Findings',
    category: 'Beneficiary Engagement',
    subcategory: 'Beneficiary Engagement',
    weight: 'medium',
    points: 20,
    supportingInfo: 'Collect and follow up on patient experience and satisfaction data including the development and implementation of improvement plans.',
    selected: false,
  },
  {
    activityId: 'IA_BE_12',
    activityDescription: 'Use evidence-based decision aids to support shared decision-making',
    category: 'Beneficiary Engagement',
    subcategory: 'Beneficiary Engagement',
    weight: 'medium',
    points: 20,
    supportingInfo: 'Use evidence-based decision aids to support shared decision-making.',
    selected: false,
  },
  {
    activityId: 'IA_BE_14',
    activityDescription: 'Engage Patients and Families to Guide Improvement in the System of Care',
    category: 'Beneficiary Engagement',
    subcategory: 'Beneficiary Engagement',
    weight: 'medium',
    points: 20,
    supportingInfo: 'Engage patients and families to guide improvement by leveraging digital tools for ongoing guidance and assessments outside the encounter.',
    selected: false,
  },
  {
    activityId: 'IA_BE_15',
    activityDescription: 'Engagement of Patients, Family, and Caregivers in Developing a Plan of Care',
    category: 'Beneficiary Engagement',
    subcategory: 'Beneficiary Engagement',
    weight: 'medium',
    points: 20,
    isMvpMeasure: true,
    supportingInfo: 'Engage patients, family, and caregivers in developing a plan of care and prioritizing their goals for action, documented in the electronic health record.',
    selected: false,
  },
  {
    activityId: 'IA_BE_16',
    activityDescription: 'Promote Self-management in Usual Care',
    category: 'Beneficiary Engagement',
    subcategory: 'Beneficiary Engagement',
    weight: 'medium',
    points: 20,
    supportingInfo: 'Incorporate culturally and linguistically tailored evidence-based techniques for promoting self-management into usual care.',
    selected: false,
  },
  {
    activityId: 'IA_BE_19',
    activityDescription: 'Use group visits for common chronic conditions (e.g., diabetes)',
    category: 'Beneficiary Engagement',
    subcategory: 'Beneficiary Engagement',
    weight: 'medium',
    points: 20,
    supportingInfo: 'Use group visits for common chronic conditions.',
    selected: false,
  },
  {
    activityId: 'IA_BE_22',
    activityDescription: 'Improved Practices that Engage Patients Pre-Visit',
    category: 'Beneficiary Engagement',
    subcategory: 'Beneficiary Engagement',
    weight: 'medium',
    points: 20,
    supportingInfo: 'Implementation of workflow changes that engage patients prior to the visit, such as pre-visit development of a shared visit agenda.',
    selected: false,
  },
  {
    activityId: 'IA_BE_23',
    activityDescription: 'Integration of patient coaching practices between visits',
    category: 'Beneficiary Engagement',
    subcategory: 'Beneficiary Engagement',
    weight: 'medium',
    points: 20,
    supportingInfo: 'Provide coaching between visits with follow-up on care plan and goals.',
    selected: false,
  },
  {
    activityId: 'IA_BE_24',
    activityDescription: 'Financial Navigation Program',
    category: 'Beneficiary Engagement',
    subcategory: 'Beneficiary Engagement',
    weight: 'medium',
    points: 20,
    supportingInfo: 'Attest that their practice provides financial counseling to patients or their caregiver about costs of care and an exploration of different payment options.',
    selected: false,
  },
  {
    activityId: 'IA_BE_25',
    activityDescription: 'Drug Cost Transparency',
    category: 'Beneficiary Engagement',
    subcategory: 'Beneficiary Engagement',
    weight: 'medium',
    points: 20,
    supportingInfo: 'Provide counseling to patients regarding costs of medications using a real time benefit tool (RTBT).',
    selected: false,
  },

  // Patient Safety and Practice Assessment
  {
    activityId: 'IA_PSPA_1',
    activityDescription: 'Participation in an AHRQ-listed patient safety organization',
    category: 'Patient Safety and Practice Assessment',
    subcategory: 'Patient Safety and Practice Assessment',
    weight: 'medium',
    points: 20,
    supportingInfo: 'Participation in an AHRQ-listed patient safety organization.',
    selected: false,
  },
  {
    activityId: 'IA_PSPA_2',
    activityDescription: 'Participation in MOC Part IV',
    category: 'Patient Safety and Practice Assessment',
    subcategory: 'Patient Safety and Practice Assessment',
    weight: 'high',
    points: 40,
    supportingInfo: 'Participate in Maintenance of Certification (MOC) Part IV which requires clinicians to perform monthly activities across practice to regularly assess performance.',
    selected: false,
  },
  {
    activityId: 'IA_PSPA_3',
    activityDescription: 'Participate in IHI Training/Forum Event; National Academy of Medicine, AHRQ Team STEPPS® or Other Similar Activity',
    category: 'Patient Safety and Practice Assessment',
    subcategory: 'Patient Safety and Practice Assessment',
    weight: 'medium',
    points: 20,
    supportingInfo: 'For MIPS eligible clinicians not participating in MOC Part IV, new engagement such as IHI Training/Forum Event, National Academy of Medicine, or AHRQ Team STEPPS®.',
    selected: false,
  },
  {
    activityId: 'IA_PSPA_4',
    activityDescription: 'Administration of the AHRQ Survey of Patient Safety Culture',
    category: 'Patient Safety and Practice Assessment',
    subcategory: 'Patient Safety and Practice Assessment',
    weight: 'medium',
    points: 20,
    supportingInfo: 'Administration of the AHRQ Survey of Patient Safety Culture and submission of data to the comparative database. Note: This activity may be selected once every 4 years.',
    selected: false,
  },
  {
    activityId: 'IA_PSPA_7',
    activityDescription: 'Use of QCDR data for ongoing practice assessment and improvements',
    category: 'Patient Safety and Practice Assessment',
    subcategory: 'Patient Safety and Practice Assessment',
    weight: 'medium',
    points: 20,
    isMvpMeasure: true,
    supportingInfo: 'Participation in a Qualified Clinical Data Registry (QCDR) and use of QCDR data for ongoing practice assessment and improvements in patient safety.',
    selected: false,
  },
  {
    activityId: 'IA_PSPA_8',
    activityDescription: 'Use of Patient Safety Tools',
    category: 'Patient Safety and Practice Assessment',
    subcategory: 'Patient Safety and Practice Assessment',
    weight: 'medium',
    points: 20,
    supportingInfo: 'Use tools that assist specialty practices in tracking specific measures that are meaningful to their practice.',
    selected: false,
  },
  {
    activityId: 'IA_PSPA_9',
    activityDescription: 'Completion of the AMA STEPS Forward program',
    category: 'Patient Safety and Practice Assessment',
    subcategory: 'Patient Safety and Practice Assessment',
    weight: 'medium',
    points: 20,
    supportingInfo: 'Completion of the American Medical Association\'s STEPS Forward program.',
    selected: false,
  },
  {
    activityId: 'IA_PSPA_12',
    activityDescription: 'Participation in private payer CPIA',
    category: 'Patient Safety and Practice Assessment',
    subcategory: 'Patient Safety and Practice Assessment',
    weight: 'medium',
    points: 20,
    supportingInfo: 'Participation in designated private payer clinical practice improvement activities.',
    selected: false,
  },
  {
    activityId: 'IA_PSPA_13',
    activityDescription: 'Participation in Joint Commission Evaluation Initiative',
    category: 'Patient Safety and Practice Assessment',
    subcategory: 'Patient Safety and Practice Assessment',
    weight: 'medium',
    points: 20,
    supportingInfo: 'Participation in Joint Commission Ongoing Professional Practice Evaluation initiative.',
    selected: false,
  },
  {
    activityId: 'IA_PSPA_15',
    activityDescription: 'Implementation of an ASP',
    category: 'Patient Safety and Practice Assessment',
    subcategory: 'Patient Safety and Practice Assessment',
    weight: 'medium',
    points: 20,
    supportingInfo: 'Leadership of an Antimicrobial Stewardship Program (ASP) that includes implementation of an ASP that measures the appropriate use of antibiotics.',
    selected: false,
  },
  {
    activityId: 'IA_PSPA_16',
    activityDescription: 'Use decision support—ideally platform-agnostic, interoperable clinical decision support (CDS) tools—and standardized treatment protocols',
    category: 'Patient Safety and Practice Assessment',
    subcategory: 'Patient Safety and Practice Assessment',
    weight: 'medium',
    points: 20,
    supportingInfo: 'Use decision support and standardized treatment protocols to manage workflow on the care team to meet patient needs.',
    selected: false,
  },
  {
    activityId: 'IA_PSPA_17',
    activityDescription: 'Implementation of analytic capabilities to manage total cost of care for practice population',
    category: 'Patient Safety and Practice Assessment',
    subcategory: 'Patient Safety and Practice Assessment',
    weight: 'medium',
    points: 20,
    supportingInfo: 'Conduct or build the capacity to conduct analytic activities to manage total cost of care for the practice population.',
    selected: false,
  },
  {
    activityId: 'IA_PSPA_18',
    activityDescription: 'Measurement and improvement at the practice and panel level',
    category: 'Patient Safety and Practice Assessment',
    subcategory: 'Patient Safety and Practice Assessment',
    weight: 'medium',
    points: 20,
    supportingInfo: 'Measure and improve quality at the practice and panel level, regularly reviewing measures of quality, utilization, patient satisfaction and other measures.',
    selected: false,
  },
  {
    activityId: 'IA_PSPA_19',
    activityDescription: 'Implementation of formal quality improvement methods, practice changes, or other practice improvement processes',
    category: 'Patient Safety and Practice Assessment',
    subcategory: 'Patient Safety and Practice Assessment',
    weight: 'medium',
    points: 20,
    supportingInfo: 'Adopt a formal model for quality improvement and create a culture in which all staff, including leadership, actively participates in improvement activities.',
    selected: false,
  },
  {
    activityId: 'IA_PSPA_21',
    activityDescription: 'Implementation of fall screening and assessment programs',
    category: 'Patient Safety and Practice Assessment',
    subcategory: 'Patient Safety and Practice Assessment',
    weight: 'medium',
    points: 20,
    supportingInfo: 'Implementation of fall screening and assessment programs to identify patients at risk for falls and address modifiable risk factors.',
    selected: false,
  },
  {
    activityId: 'IA_PSPA_22',
    activityDescription: 'CDC Training on CDC\'s Guideline for Prescribing Opioids for Chronic Pain',
    category: 'Patient Safety and Practice Assessment',
    subcategory: 'Patient Safety and Practice Assessment',
    weight: 'medium',
    points: 20,
    supportingInfo: 'Completion of all modules of the CDC course "Applying CDC\'s Guideline for Prescribing Opioids". Note: This activity may be selected once every 4 years.',
    selected: false,
  },
  {
    activityId: 'IA_PSPA_23',
    activityDescription: 'Completion of CDC Training on Antibiotic Stewardship',
    category: 'Patient Safety and Practice Assessment',
    subcategory: 'Patient Safety and Practice Assessment',
    weight: 'medium',
    points: 20,
    supportingInfo: 'Completion of all modules of the CDC antibiotic stewardship course. Note: This activity may be selected once every 4 years.',
    selected: false,
  },
  {
    activityId: 'IA_PSPA_25',
    activityDescription: 'Cost Display for Laboratory and Radiographic Orders',
    category: 'Patient Safety and Practice Assessment',
    subcategory: 'Patient Safety and Practice Assessment',
    weight: 'medium',
    points: 20,
    supportingInfo: 'Implementation of a cost display for laboratory and radiographic orders.',
    selected: false,
  },
  {
    activityId: 'IA_PSPA_26',
    activityDescription: 'Communication of Unscheduled Visit for Adverse Drug Event and Nature of Event',
    category: 'Patient Safety and Practice Assessment',
    subcategory: 'Patient Safety and Practice Assessment',
    weight: 'medium',
    points: 20,
    supportingInfo: 'A MIPS eligible clinician providing unscheduled care attests that for greater than 75 percent of case visits from a clinically significant adverse drug event, provides information to the patient\'s primary care clinician within 48 hours.',
    selected: false,
  },
  {
    activityId: 'IA_PSPA_28',
    activityDescription: 'Completion of an Accredited Safety or Quality Improvement Program',
    category: 'Patient Safety and Practice Assessment',
    subcategory: 'Patient Safety and Practice Assessment',
    weight: 'medium',
    points: 20,
    supportingInfo: 'Completion of an accredited performance improvement continuing medical education (CME) program that addresses performance or quality improvement.',
    selected: false,
  },
  {
    activityId: 'IA_PSPA_31',
    activityDescription: 'Patient Medication Risk Education',
    category: 'Patient Safety and Practice Assessment',
    subcategory: 'Patient Safety and Practice Assessment',
    weight: 'medium',
    points: 20,
    supportingInfo: 'Provide both written and verbal education regarding the risks of concurrent opioid and benzodiazepine use for at least 75% of qualifying patients.',
    selected: false,
  },
  {
    activityId: 'IA_PSPA_32',
    activityDescription: 'Use of CDC Guideline for Clinical Decision Support to Prescribe Opioids for Chronic Pain via Clinical Decision Support',
    category: 'Patient Safety and Practice Assessment',
    subcategory: 'Patient Safety and Practice Assessment',
    weight: 'medium',
    points: 20,
    supportingInfo: 'Utilize the CDC Guideline for Prescribing Opioids for Chronic Pain via clinical decision support (CDS) built directly into the clinician workflow.',
    selected: false,
  },
  {
    activityId: 'IA_PSPA_33',
    activityDescription: 'Application of CDC\'s Training for Healthcare Providers on Lyme Disease',
    category: 'Patient Safety and Practice Assessment',
    subcategory: 'Patient Safety and Practice Assessment',
    weight: 'medium',
    points: 20,
    supportingInfo: 'Apply the CDC\'s Training for Healthcare Providers on Lyme Disease using clinical decision support (CDS) built directly into the clinician workflow.',
    selected: false,
  },

  // Achieving Health Equity
  {
    activityId: 'IA_AHE_1',
    activityDescription: 'Enhance Engagement of Medicaid and Other Underserved Populations',
    category: 'Achieving Health Equity',
    subcategory: 'Achieving Health Equity',
    weight: 'medium',
    points: 20,
    supportingInfo: 'Use time-to-treat data to identify patterns by which care for Medicaid patients or other underserved patients has not achieved standard practice guidelines and create an approach for improvement.',
    selected: false,
  },
  {
    activityId: 'IA_AHE_3',
    activityDescription: 'Promote Use of Patient-Reported Outcome Tools',
    category: 'Achieving Health Equity',
    subcategory: 'Achieving Health Equity',
    weight: 'medium',
    points: 20,
    isMvpMeasure: true,
    supportingInfo: 'Demonstrate performance of activities for employing patient-reported outcome (PRO) tools and corresponding collection of PRO data.',
    selected: false,
  },
  {
    activityId: 'IA_AHE_5',
    activityDescription: 'Health equity improvement (SUSPENDED)',
    category: 'Achieving Health Equity',
    subcategory: 'Achieving Health Equity',
    weight: 'medium',
    points: 20,
    isMvpMeasure: true,
    supportingInfo: 'This activity has been suspended for the 2025 performance period. However, if this activity has already been completed or was in the process of being completed, you can still attest to completing it and receive credit.',
    selected: false,
    suspended: true,
  },
  {
    activityId: 'IA_AHE_6',
    activityDescription: 'Provide Education Opportunities for New Clinicians',
    category: 'Achieving Health Equity',
    subcategory: 'Achieving Health Equity',
    weight: 'medium',
    points: 20,
    supportingInfo: 'MIPS eligible clinicians acting as a preceptor for clinicians-in-training and accepting such clinicians for clinical rotations in community practices in small, underserved, or rural areas.',
    selected: false,
  },
  {
    activityId: 'IA_AHE_7',
    activityDescription: 'Comprehensive Eye Exams',
    category: 'Achieving Health Equity',
    subcategory: 'Achieving Health Equity',
    weight: 'medium',
    points: 20,
    supportingInfo: 'Promote the importance of a comprehensive eye exam targeted at underserved and/or high-risk populations.',
    selected: false,
  },
  {
    activityId: 'IA_AHE_8',
    activityDescription: 'Underserved population support (SUSPENDED)',
    category: 'Achieving Health Equity',
    subcategory: 'Achieving Health Equity',
    weight: 'medium',
    points: 20,
    supportingInfo: 'This activity has been suspended for the 2025 performance period. However, if this activity has already been completed or was in the process of being completed, you can still attest to completing it and receive credit.',
    selected: false,
    suspended: true,
  },
  {
    activityId: 'IA_AHE_9',
    activityDescription: 'Community health support (SUSPENDED)',
    category: 'Achieving Health Equity',
    subcategory: 'Achieving Health Equity',
    weight: 'medium',
    points: 20,
    supportingInfo: 'This activity has been suspended for the 2025 performance period. However, if this activity has already been completed or was in the process of being completed, you can still attest to completing it and receive credit.',
    selected: false,
    suspended: true,
  },
  {
    activityId: 'IA_AHE_10',
    activityDescription: 'Adopt Certified Health Information Technology for Security Tags for Electronic Health Record Data',
    category: 'Achieving Health Equity',
    subcategory: 'Achieving Health Equity',
    weight: 'medium',
    points: 20,
    supportingInfo: 'Use security labeling services available in certified Health Information Technology (IT) for electronic health record (EHR) data to facilitate data segmentation.',
    selected: false,
  },
  {
    activityId: 'IA_AHE_11',
    activityDescription: 'Health disparities reduction (SUSPENDED)',
    category: 'Achieving Health Equity',
    subcategory: 'Achieving Health Equity',
    weight: 'medium',
    points: 20,
    supportingInfo: 'This activity has been suspended for the 2025 performance period. However, if this activity has already been completed or was in the process of being completed, you can still attest to completing it and receive credit.',
    selected: false,
    suspended: true,
  },
  {
    activityId: 'IA_AHE_12',
    activityDescription: 'Vulnerable population care (SUSPENDED)',
    category: 'Achieving Health Equity',
    subcategory: 'Achieving Health Equity',
    weight: 'medium',
    points: 20,
    supportingInfo: 'This activity has been suspended for the 2025 performance period. However, if this activity has already been completed or was in the process of being completed, you can still attest to completing it and receive credit.',
    selected: false,
    suspended: true,
  },

  // Emergency Response And Preparedness
  {
    activityId: 'IA_ERP_1',
    activityDescription: 'Participation on Disaster Medical Assistance Team, registered for 6 months',
    category: 'Emergency Response And Preparedness',
    subcategory: 'Emergency Response And Preparedness',
    weight: 'medium',
    points: 20,
    supportingInfo: 'Participation in Disaster Medical Assistance Teams or Community Emergency Responder Teams. MIPS eligible clinicians must be registered for a minimum of 6 months as a volunteer.',
    selected: false,
  },
  {
    activityId: 'IA_ERP_2',
    activityDescription: 'Participation in a 60-day or greater effort to support domestic or international humanitarian needs',
    category: 'Emergency Response And Preparedness',
    subcategory: 'Emergency Response And Preparedness',
    weight: 'medium',
    points: 20,
    supportingInfo: 'Participation in domestic or international humanitarian volunteer work for a period of a continuous 60 days or greater.',
    selected: false,
  },
  {
    activityId: 'IA_ERP_3',
    activityDescription: 'Emergency preparedness (SUSPENDED)',
    category: 'Emergency Response And Preparedness',
    subcategory: 'Emergency Response And Preparedness',
    weight: 'medium',
    points: 20,
    supportingInfo: 'This activity has been suspended for the 2025 performance period. However, if this activity has already been completed or was in the process of being completed, you can still attest to completing it and receive credit.',
    selected: false,
    suspended: true,
  },

  // Behavioral And Mental Health
  {
    activityId: 'IA_BMH_1',
    activityDescription: 'Diabetes screening',
    category: 'Behavioral And Mental Health',
    subcategory: 'Behavioral And Mental Health',
    weight: 'medium',
    points: 20,
    supportingInfo: 'Diabetes screening for people with schizophrenia or bipolar disease who are using antipsychotic medication.',
    selected: false,
  },
  {
    activityId: 'IA_BMH_2',
    activityDescription: 'Tobacco use',
    category: 'Behavioral And Mental Health',
    subcategory: 'Behavioral And Mental Health',
    weight: 'medium',
    points: 20,
    supportingInfo: 'Regular engagement in integrated prevention and treatment interventions, including tobacco use screening and cessation interventions for patients with co-occurring behavioral or mental health conditions.',
    selected: false,
  },
  {
    activityId: 'IA_BMH_4',
    activityDescription: 'Depression screening',
    category: 'Behavioral And Mental Health',
    subcategory: 'Behavioral And Mental Health',
    weight: 'medium',
    points: 20,
    supportingInfo: 'Regular engagement in integrated prevention and treatment interventions, including depression screening and follow-up plan for patients with co-occurring behavioral or mental health conditions.',
    selected: false,
  },
  {
    activityId: 'IA_BMH_5',
    activityDescription: 'MDD prevention and treatment interventions',
    category: 'Behavioral And Mental Health',
    subcategory: 'Behavioral And Mental Health',
    weight: 'medium',
    points: 20,
    supportingInfo: 'Regular engagement in integrated prevention and treatment interventions, including suicide risk assessment for mental health patients with co-occurring conditions.',
    selected: false,
  },
  {
    activityId: 'IA_BMH_7',
    activityDescription: 'Implementation of Integrated Patient Centered Behavioral Health Model',
    category: 'Behavioral And Mental Health',
    subcategory: 'Behavioral And Mental Health',
    weight: 'medium',
    points: 20,
    supportingInfo: 'Offer integrated behavioral health services to support patients with behavioral health needs who also have conditions such as dementia or other poorly controlled chronic illnesses.',
    selected: false,
  },
  {
    activityId: 'IA_BMH_8',
    activityDescription: 'Electronic Health Record Enhancements for BH data capture',
    category: 'Behavioral And Mental Health',
    subcategory: 'Behavioral And Mental Health',
    weight: 'medium',
    points: 20,
    supportingInfo: 'Enhancements to an electronic health record to capture additional data on behavioral health (BH) populations and use that data for additional decision-making purposes.',
    selected: false,
  },
  {
    activityId: 'IA_BMH_9',
    activityDescription: 'Unhealthy Alcohol Use for Patients with Co-occurring Conditions of Mental Health and Substance Abuse',
    category: 'Behavioral And Mental Health',
    subcategory: 'Behavioral And Mental Health',
    weight: 'medium',
    points: 20,
    supportingInfo: 'Regularly engage in integrated prevention and treatment interventions, including screening and brief counseling for patients with co-occurring conditions of mental health and substance abuse.',
    selected: false,
  },
  {
    activityId: 'IA_BMH_10',
    activityDescription: 'Completion of Collaborative Care Management Training Program',
    category: 'Behavioral And Mental Health',
    subcategory: 'Behavioral And Mental Health',
    weight: 'medium',
    points: 20,
    supportingInfo: 'Complete a collaborative care management training program to implement a collaborative care management approach that integrates behavioral health into primary care practice.',
    selected: false,
  },
  {
    activityId: 'IA_BMH_11',
    activityDescription: 'Implementation of a Trauma-Informed Care (TIC) Approach to Clinical Practice',
    category: 'Behavioral And Mental Health',
    subcategory: 'Behavioral And Mental Health',
    weight: 'medium',
    points: 20,
    supportingInfo: 'Create and implement a plan for trauma-informed care (TIC) that recognizes the potential impact of trauma experiences on patients.',
    selected: false,
  },
  {
    activityId: 'IA_BMH_12',
    activityDescription: 'Promoting Clinician Well-Being',
    category: 'Behavioral And Mental Health',
    subcategory: 'Behavioral And Mental Health',
    weight: 'medium',
    points: 20,
    supportingInfo: 'Develop and implement programs to support clinician well-being and resilience through relationship-building opportunities or leadership development plans.',
    selected: false,
  },
  {
    activityId: 'IA_BMH_14',
    activityDescription: 'Behavioral/Mental Health and Substance Use Screening & Referral for Pregnant and Postpartum Women',
    category: 'Behavioral And Mental Health',
    subcategory: 'Behavioral And Mental Health',
    weight: 'medium',
    points: 20,
    supportingInfo: 'Screen for perinatal mood and anxiety disorders (PMADs) and substance use disorder (SUD) in pregnant and postpartum women.',
    selected: false,
  },
  {
    activityId: 'IA_BMH_15',
    activityDescription: 'Behavioral/Mental Health and Substance Use Screening & Referral for Older Adults',
    category: 'Behavioral And Mental Health',
    subcategory: 'Behavioral And Mental Health',
    weight: 'medium',
    points: 20,
    supportingInfo: 'Complete age-appropriate screening for mental health and substance use in older adults.',
    selected: false,
  },

  // MIPS Value Pathways
  {
    activityId: 'IA_MVP',
    activityDescription: 'Practice-Wide Quality Improvement in MIPS Value Pathways',
    category: 'MIPS Value Pathways',
    subcategory: 'MIPS Value Pathways',
    weight: 'medium',
    points: 20,
    isMvpMeasure: true,
    supportingInfo: 'Create a quality improvement initiative within your practice that involves a minimum of three of the measures within a specific MVP. Requires participation in MVPs.',
    selected: false,
  },
  {
    activityId: 'IA_PCMH',
    activityDescription: 'Electronic submission of Patient Centered Medical Home accreditation',
    category: 'MIPS Value Pathways',
    subcategory: 'MIPS Value Pathways',
    weight: 'high',
    points: 40,
    isMvpMeasure: true,
    supportingInfo: 'I attest that I am a Patient Centered Medical Home (PCMH) or Comparable Specialty Practice that has been recognized/accredited by a national or State agency. This activity gives full credit (40 points) regardless of special status.',
    selected: false,
  },
];

export const IA_ACTIVITIES_2026: ImprovementActivity[] = [
  // Expanded Practice Access
  {
    activityId: 'IA_EPA_2',
    activityDescription: 'Use of telehealth services that expand practice access',
    category: 'Expanded Practice Access',
    subcategory: 'Expanded Practice Access',
    weight: 'medium',
    points: 20,
    supportingInfo: 'Create and implement a standardized process for providing telehealth services to expand access to care.',
    selected: false,
  },
  {
    activityId: 'IA_EPA_3',
    activityDescription: 'Collection and use of patient experience and satisfaction data on access',
    category: 'Expanded Practice Access',
    subcategory: 'Expanded Practice Access',
    weight: 'medium',
    points: 20,
    supportingInfo: 'Collection of patient experience and satisfaction data on access to care and development of an improvement plan, such as outlining steps for improving communications with patients to help understanding of urgent access needs.',
    selected: false,
  },
  {
    activityId: 'IA_EPA_4',
    activityDescription: 'Additional improvements in access as a result of QIN/QIO TA',
    category: 'Expanded Practice Access',
    subcategory: 'Expanded Practice Access',
    weight: 'medium',
    points: 20,
    supportingInfo: 'As a result of Quality Innovation Network-Quality Improvement Organization technical assistance, performance of additional activities that improve access to services or improve care coordination (for example, investment of on-site diabetes educator).',
    selected: false,
  },
  {
    activityId: 'IA_EPA_5',
    activityDescription: 'Participation in User Testing of the Quality Payment Program Website (https://qpp.cms.gov/)',
    category: 'Expanded Practice Access',
    subcategory: 'Expanded Practice Access',
    weight: 'medium',
    points: 20,
    supportingInfo: 'User participation in the Quality Payment Program website testing is an activity for eligible clinicians who have worked with CMS to provide substantive, timely, and responsive input to improve the CMS Quality Payment Program website through product user-testing.',
    selected: false,
  },
  {
    activityId: 'IA_EPA_6',
    activityDescription: 'Create and Implement a Language Access Plan',
    category: 'Expanded Practice Access',
    subcategory: 'Expanded Practice Access',
    weight: 'medium',
    points: 20,
    supportingInfo: 'Create and implement a language access plan to address communication barriers for individuals with limited English proficiency. The language access plan must align with standards for communication and language assistance defined in the National Standards for Culturally and Linguistically Appropriate Services (CLAS) in Health and Health Care.',
    selected: false,
  },
  {
    activityId: 'IA_EPA_7',
    activityDescription: 'Enhance Engagement of Medicaid and Other Underserved Populations',
    category: 'Expanded Practice Access',
    subcategory: 'Expanded Practice Access',
    weight: 'medium',
    points: 20,
    supportingInfo: 'Use time-to-treat data to identify patterns by which care for Medicaid patients or other underserved patients has not achieved standard practice guidelines and create an approach for improvement.',
    selected: false,
  },
  {
    activityId: 'IA_EPA_8',
    activityDescription: 'Provide Education Opportunities for New Clinicians',
    category: 'Expanded Practice Access',
    subcategory: 'Expanded Practice Access',
    weight: 'medium',
    points: 20,
    supportingInfo: 'MIPS eligible clinicians acting as a preceptor for clinicians-in-training and accepting such clinicians for clinical rotations in community practices in small, underserved, or rural areas.',
    selected: false,
  },

  // Population Management
  {
    activityId: 'IA_PM_2',
    activityDescription: 'Anticoagulant Management Improvements',
    category: 'Population Management',
    subcategory: 'Population Management',
    weight: 'medium',
    points: 20,
    supportingInfo: 'Individual MIPS eligible clinicians and groups who prescribe anti-coagulation medications must attest that for 75 percent of their ambulatory care patients receiving these medications are being managed with support from systematic anticoagulation programs.',
    selected: false,
  },
  {
    activityId: 'IA_PM_3',
    activityDescription: 'RHC, IHS or FQHC quality improvement activities',
    category: 'Population Management',
    subcategory: 'Population Management',
    weight: 'medium',
    points: 20,
    supportingInfo: 'Participating in a Rural Health Clinic (RHC), Indian Health Service Medium Management (IHS), or Federally Qualified Health Center in ongoing engagement activities that contribute to more formal quality reporting.',
    selected: false,
  },
  {
    activityId: 'IA_PM_4',
    activityDescription: 'Glycemic management services',
    category: 'Population Management',
    subcategory: 'Population Management',
    weight: 'medium',
    points: 20,
    supportingInfo: 'For outpatient Medicare beneficiaries with diabetes and who are prescribed antidiabetic agents, must attest to having at least 60 percent of medical records with documentation of an individualized glycemic treatment goal.',
    selected: false,
  },
  {
    activityId: 'IA_PM_5',
    activityDescription: 'Engagement of community for health status improvement',
    category: 'Population Management',
    subcategory: 'Population Management',
    weight: 'medium',
    points: 20,
    supportingInfo: 'Take steps to improve health status of communities, such as collaborating with key partners and stakeholders to implement evidenced-based practices to improve a specific chronic condition.',
    selected: false,
  },
  {
    activityId: 'IA_PM_11',
    activityDescription: 'Regular review practices in place on targeted patient population needs',
    category: 'Population Management',
    subcategory: 'Population Management',
    weight: 'medium',
    points: 20,
    supportingInfo: 'Implement regular reviews of targeted patient population needs, such as structured clinical case reviews. Reviews should stratify patient data by demographic characteristics and health related social needs.',
    selected: false,
  },
  {
    activityId: 'IA_PM_14',
    activityDescription: 'Implementation of methodologies for improvements in longitudinal care management for high risk patients',
    category: 'Population Management',
    subcategory: 'Population Management',
    weight: 'medium',
    points: 20,
    supportingInfo: 'Provide longitudinal care management to patients at high risk for adverse health outcome or harm using consistent methods to assign and adjust global risk status.',
    selected: false,
  },
  {
    activityId: 'IA_PM_15',
    activityDescription: 'Implementation of episodic care management practice improvements',
    category: 'Population Management',
    subcategory: 'Population Management',
    weight: 'medium',
    points: 20,
    supportingInfo: 'Provide episodic care management, including management across transitions and referrals with routine and timely follow-up to hospitalizations, ED visits and stays in other institutional settings.',
    selected: false,
  },
  {
    activityId: 'IA_PM_16',
    activityDescription: 'Implementation of medication management practice improvements',
    category: 'Population Management',
    subcategory: 'Population Management',
    weight: 'medium',
    points: 20,
    isMvpMeasure: true,
    supportingInfo: 'Manage medications to maximize efficiency, effectiveness and safety including reconciling medications across transitions of care and conducting periodic structured medication reviews.',
    selected: false,
  },
  {
    activityId: 'IA_PM_17',
    activityDescription: 'Participation in Population Health Research',
    category: 'Population Management',
    subcategory: 'Population Management',
    weight: 'medium',
    points: 20,
    supportingInfo: 'Participation in federally and/or privately funded research that identifies interventions, tools, or processes that can improve a targeted patient population.',
    selected: false,
  },
  {
    activityId: 'IA_PM_18',
    activityDescription: 'Provide Clinical-Community Linkages',
    category: 'Population Management',
    subcategory: 'Population Management',
    weight: 'medium',
    points: 20,
    supportingInfo: 'Engaging community health workers to provide a comprehensive link to community resources through family-based services focusing on success in health, education, and self-sufficiency.',
    selected: false,
  },
  {
    activityId: 'IA_PM_19',
    activityDescription: 'Glycemic Screening Services',
    category: 'Population Management',
    subcategory: 'Population Management',
    weight: 'medium',
    points: 20,
    supportingInfo: 'For at-risk outpatient Medicare beneficiaries, attest to implementation of systematic preventive approaches in clinical practice for at least 60 percent of electronic medical records with documentation of screening patients for abnormal blood glucose.',
    selected: false,
  },
  {
    activityId: 'IA_PM_20',
    activityDescription: 'Glycemic Referring Services',
    category: 'Population Management',
    subcategory: 'Population Management',
    weight: 'medium',
    points: 20,
    supportingInfo: 'For at-risk outpatient Medicare beneficiaries, attest to implementation of systematic preventive approaches for at least 60 percent of medical records with documentation of referring eligible patients with prediabetes to a CDC-recognized diabetes prevention program.',
    selected: false,
  },
  {
    activityId: 'IA_PM_21',
    activityDescription: 'Advance Care Planning',
    category: 'Population Management',
    subcategory: 'Population Management',
    weight: 'medium',
    points: 20,
    supportingInfo: 'Implementation of practices/processes to develop advance care planning that includes documenting the advance care plan or living will within the medical record.',
    selected: false,
  },
  {
    activityId: 'IA_PM_22',
    activityDescription: 'Improving Practice Capacity for Human Immunodeficiency Virus (HIV) Prevention Services',
    category: 'Population Management',
    subcategory: 'Population Management',
    weight: 'medium',
    points: 20,
    supportingInfo: 'Establish policies and procedures to improve practice capacity to increase HIV prevention screening, improve HIV prevention education and awareness, and reduce disparities in pre-exposure prophylaxis (PrEP) uptake.',
    selected: false,
  },
  {
    activityId: 'IA_PM_23',
    activityDescription: 'Use of Computable Guidelines and Clinical Decision Support to Improve Adherence for Cervical Cancer Screening and Management Guidelines',
    category: 'Population Management',
    subcategory: 'Population Management',
    weight: 'medium',
    points: 20,
    supportingInfo: 'Incorporate the Cervical Cancer Screening and Management (CCSM) Clinical Decision Support (CDS) tool within the electronic health record (EHR) system to provide clinicians with ready access to the most up-to-date clinical practice guidelines.',
    selected: false,
  },
  {
    activityId: 'IA_PM_24',
    activityDescription: 'Implementation of Protocols and Provision of Resources to Increase Lung Cancer Screening Uptake',
    category: 'Population Management',
    subcategory: 'Population Management',
    weight: 'medium',
    points: 20,
    supportingInfo: 'Establish a process or procedure to increase rates of lung cancer screening through implementation of protocols that support enhanced documentation methods to identify eligible patients.',
    selected: false,
  },
  {
    activityId: 'IA_PM_25',
    activityDescription: 'Save a Million Hearts: Standardization of Approach to Screening and Treatment for Cardiovascular Disease Risk',
    category: 'Population Management',
    subcategory: 'Population Management',
    weight: 'medium',
    points: 20,
    supportingInfo: 'Implement standardized, evidence-based cardiovascular disease risk assessment and care management for a defined population in the clinician\'s practice.',
    selected: false,
  },
  {
    activityId: 'IA_PM_27',
    activityDescription: 'Improving Detection of Cognitive Impairment in Primary Care',
    category: 'Population Management',
    subcategory: 'Population Management',
    weight: 'medium',
    points: 20,
    supportingInfo: 'Implement systematic processes to detect and document cognitive impairment in the primary care setting, including use of validated screening tools and referral pathways for follow-up care.',
    selected: false,
  },
  {
    activityId: 'IA_PM_28',
    activityDescription: 'Integrating Oral Health Care in Primary Care',
    category: 'Population Management',
    subcategory: 'Population Management',
    weight: 'medium',
    points: 20,
    supportingInfo: 'Integrate oral health assessment and referral processes into primary care settings, including training staff on oral health screenings and establishing referral pathways to dental providers.',
    selected: false,
  },

  // Care Coordination
  {
    activityId: 'IA_CC_7',
    activityDescription: 'Regular training in care coordination',
    category: 'Care Coordination',
    subcategory: 'Care Coordination',
    weight: 'medium',
    points: 20,
    supportingInfo: 'Implementation of regular care coordination training.',
    selected: false,
  },
  {
    activityId: 'IA_CC_8',
    activityDescription: 'Implementation of documentation improvements for practice/process improvements',
    category: 'Care Coordination',
    subcategory: 'Care Coordination',
    weight: 'medium',
    points: 20,
    supportingInfo: 'Implementation of practices/processes that document care coordination activities (e.g., a documented care coordination encounter that tracks all clinical staff involved).',
    selected: false,
  },
  {
    activityId: 'IA_CC_9',
    activityDescription: 'Implementation of practices/processes for developing regular individual care plans',
    category: 'Care Coordination',
    subcategory: 'Care Coordination',
    weight: 'medium',
    points: 20,
    supportingInfo: 'Implementation of practices/processes to develop regularly updated individual care plans for at-risk patients that are shared with the beneficiary or caregiver(s).',
    selected: false,
  },
  {
    activityId: 'IA_CC_10',
    activityDescription: 'Care transition documentation practice improvements',
    category: 'Care Coordination',
    subcategory: 'Care Coordination',
    weight: 'medium',
    points: 20,
    supportingInfo: 'Document practices/processes for care transition with documentation of how a MIPS eligible clinician or group carried out an action plan for the patient during the first 30 days following a discharge.',
    selected: false,
  },
  {
    activityId: 'IA_CC_11',
    activityDescription: 'Care transition standard operational improvements',
    category: 'Care Coordination',
    subcategory: 'Care Coordination',
    weight: 'medium',
    points: 20,
    supportingInfo: 'Establish standard operations to manage transitions of care including establishing formalized lines of communication with local settings.',
    selected: false,
  },
  {
    activityId: 'IA_CC_12',
    activityDescription: 'Care coordination agreements that promote improvements in patient tracking across settings',
    category: 'Care Coordination',
    subcategory: 'Care Coordination',
    weight: 'medium',
    points: 20,
    supportingInfo: 'Establish effective care coordination and active referral management including establishing care coordination agreements with frequently used consultants.',
    selected: false,
  },
  {
    activityId: 'IA_CC_13',
    activityDescription: 'Practice improvements to align with OpenNotes principles',
    category: 'Care Coordination',
    subcategory: 'Care Coordination',
    weight: 'medium',
    points: 20,
    isMvpMeasure: true,
    supportingInfo: 'Adherence to the principles described in the OpenNotes initiative to ensure that patients have full access to their patient information to guide patient care.',
    selected: false,
  },
  {
    activityId: 'IA_CC_15',
    activityDescription: 'PSH Care Coordination',
    category: 'Care Coordination',
    subcategory: 'Care Coordination',
    weight: 'medium',
    points: 20,
    supportingInfo: 'Participation in a Perioperative Surgical Home (PSH) that provides a patient-centered, physician-led, interdisciplinary, and team-based system of coordinated patient care.',
    selected: false,
  },
  {
    activityId: 'IA_CC_16',
    activityDescription: 'Primary Care Physician and Behavioral Health Bilateral Electronic Exchange of Information for Shared Patients',
    category: 'Care Coordination',
    subcategory: 'Care Coordination',
    weight: 'medium',
    points: 20,
    supportingInfo: 'The primary care and behavioral health practices use the same electronic health record system for shared patients or have an established bidirectional flow of records.',
    selected: false,
  },
  {
    activityId: 'IA_CC_17',
    activityDescription: 'Patient Navigator Program',
    category: 'Care Coordination',
    subcategory: 'Care Coordination',
    weight: 'medium',
    points: 20,
    supportingInfo: 'Implement a Patient Navigator Program that offers evidence-based resources and tools to reduce avoidable hospital readmissions.',
    selected: false,
  },
  {
    activityId: 'IA_CC_18',
    activityDescription: 'Relationship-Centered Communication',
    category: 'Care Coordination',
    subcategory: 'Care Coordination',
    weight: 'medium',
    points: 20,
    supportingInfo: 'MIPS eligible clinicians must participate in a minimum of eight hours of training on relationship-centered care tenets.',
    selected: false,
  },
  {
    activityId: 'IA_CC_19',
    activityDescription: 'Tracking of clinician\'s relationship to and responsibility for a patient by reporting MACRA patient relationship codes',
    category: 'Care Coordination',
    subcategory: 'Care Coordination',
    weight: 'medium',
    points: 20,
    supportingInfo: 'Attest that they reported MACRA patient relationship codes (PRC) using the applicable HCPCS modifiers on 50 percent or more of their Medicare claims for a minimum of a continuous 90-day period.',
    selected: false,
  },

  // Beneficiary Engagement
  {
    activityId: 'IA_BE_1',
    activityDescription: 'Use of certified EHR to capture patient reported outcomes',
    category: 'Beneficiary Engagement',
    subcategory: 'Beneficiary Engagement',
    weight: 'medium',
    points: 20,
    supportingInfo: 'Perform activities that enable capture of patient reported outcomes through use of certified electronic health record technology.',
    selected: false,
  },
  {
    activityId: 'IA_BE_3',
    activityDescription: 'Engagement with QIN-QIO to implement self-management training programs',
    category: 'Beneficiary Engagement',
    subcategory: 'Beneficiary Engagement',
    weight: 'medium',
    points: 20,
    supportingInfo: 'Engagement with a Quality Innovation Network-Quality Improvement Organization, which may include participation in self-management training programs such as diabetes.',
    selected: false,
  },
  {
    activityId: 'IA_BE_4',
    activityDescription: 'Engagement of Patients through Implementation of New Patient Portal',
    category: 'Beneficiary Engagement',
    subcategory: 'Beneficiary Engagement',
    weight: 'high',
    points: 20,
    isMvpMeasure: true,
    supportingInfo: 'Provide access to an enhanced patient/caregiver portal that allows users to engage in bidirectional information exchange.',
    selected: false,
  },
  {
    activityId: 'IA_BE_5',
    activityDescription: 'Enhancements/regular updates to practice websites/tools that also include considerations for patients with cognitive disabilities',
    category: 'Beneficiary Engagement',
    subcategory: 'Beneficiary Engagement',
    weight: 'medium',
    points: 20,
    supportingInfo: 'Enhancements and ongoing regular updates and use of websites/tools that include consideration for compliance with section 508 of the Rehabilitation Act of 1973.',
    selected: false,
  },
  {
    activityId: 'IA_BE_6',
    activityDescription: 'Regularly Assess Patient Experience of Care and Follow Up on Findings',
    category: 'Beneficiary Engagement',
    subcategory: 'Beneficiary Engagement',
    weight: 'medium',
    points: 20,
    supportingInfo: 'Collect and follow up on patient experience and satisfaction data including the development and implementation of improvement plans.',
    selected: false,
  },
  {
    activityId: 'IA_BE_12',
    activityDescription: 'Use evidence-based decision aids to support shared decision-making',
    category: 'Beneficiary Engagement',
    subcategory: 'Beneficiary Engagement',
    weight: 'medium',
    points: 20,
    supportingInfo: 'Use evidence-based decision aids to support shared decision-making.',
    selected: false,
  },
  {
    activityId: 'IA_BE_14',
    activityDescription: 'Engage Patients and Families to Guide Improvement in the System of Care',
    category: 'Beneficiary Engagement',
    subcategory: 'Beneficiary Engagement',
    weight: 'medium',
    points: 20,
    supportingInfo: 'Engage patients and families to guide improvement by leveraging digital tools for ongoing guidance and assessments outside the encounter.',
    selected: false,
  },
  {
    activityId: 'IA_BE_15',
    activityDescription: 'Engagement of Patients, Family, and Caregivers in Developing a Plan of Care',
    category: 'Beneficiary Engagement',
    subcategory: 'Beneficiary Engagement',
    weight: 'medium',
    points: 20,
    isMvpMeasure: true,
    supportingInfo: 'Engage patients, family, and caregivers in developing a plan of care and prioritizing their goals for action, documented in the electronic health record.',
    selected: false,
  },
  {
    activityId: 'IA_BE_16',
    activityDescription: 'Promote Self-management in Usual Care',
    category: 'Beneficiary Engagement',
    subcategory: 'Beneficiary Engagement',
    weight: 'medium',
    points: 20,
    supportingInfo: 'Incorporate culturally and linguistically tailored evidence-based techniques for promoting self-management into usual care.',
    selected: false,
  },
  {
    activityId: 'IA_BE_19',
    activityDescription: 'Use group visits for common chronic conditions (e.g., diabetes)',
    category: 'Beneficiary Engagement',
    subcategory: 'Beneficiary Engagement',
    weight: 'medium',
    points: 20,
    supportingInfo: 'Use group visits for common chronic conditions.',
    selected: false,
  },
  {
    activityId: 'IA_BE_22',
    activityDescription: 'Improved Practices that Engage Patients Pre-Visit',
    category: 'Beneficiary Engagement',
    subcategory: 'Beneficiary Engagement',
    weight: 'medium',
    points: 20,
    supportingInfo: 'Implementation of workflow changes that engage patients prior to the visit, such as pre-visit development of a shared visit agenda.',
    selected: false,
  },
  {
    activityId: 'IA_BE_23',
    activityDescription: 'Integration of patient coaching practices between visits',
    category: 'Beneficiary Engagement',
    subcategory: 'Beneficiary Engagement',
    weight: 'medium',
    points: 20,
    supportingInfo: 'Provide coaching between visits with follow-up on care plan and goals.',
    selected: false,
  },
  {
    activityId: 'IA_BE_24',
    activityDescription: 'Financial Navigation Program',
    category: 'Beneficiary Engagement',
    subcategory: 'Beneficiary Engagement',
    weight: 'medium',
    points: 20,
    supportingInfo: 'Attest that their practice provides financial counseling to patients or their caregiver about costs of care and an exploration of different payment options.',
    selected: false,
  },
  {
    activityId: 'IA_BE_25',
    activityDescription: 'Drug Cost Transparency',
    category: 'Beneficiary Engagement',
    subcategory: 'Beneficiary Engagement',
    weight: 'medium',
    points: 20,
    supportingInfo: 'Provide counseling to patients regarding costs of medications using a real time benefit tool (RTBT).',
    selected: false,
  },
  {
    activityId: 'IA_BE_26',
    activityDescription: 'Promote Use of Patient-Reported Outcome Tools',
    category: 'Beneficiary Engagement',
    subcategory: 'Beneficiary Engagement',
    weight: 'medium',
    points: 20,
    isMvpMeasure: true,
    supportingInfo: 'Demonstrate performance of activities for employing patient-reported outcome (PRO) tools and corresponding collection of PRO data.',
    selected: false,
  },
  {
    activityId: 'IA_BE_27',
    activityDescription: 'Comprehensive Eye Exams',
    category: 'Beneficiary Engagement',
    subcategory: 'Beneficiary Engagement',
    weight: 'medium',
    points: 20,
    supportingInfo: 'Promote the importance of a comprehensive eye exam targeted at underserved and/or high-risk populations.',
    selected: false,
  },

  // Patient Safety and Practice Assessment
  {
    activityId: 'IA_PSPA_1',
    activityDescription: 'Participation in an AHRQ-listed patient safety organization',
    category: 'Patient Safety and Practice Assessment',
    subcategory: 'Patient Safety and Practice Assessment',
    weight: 'medium',
    points: 20,
    supportingInfo: 'Participation in an AHRQ-listed patient safety organization.',
    selected: false,
  },
  {
    activityId: 'IA_PSPA_2',
    activityDescription: 'Participation in MOC Part IV',
    category: 'Patient Safety and Practice Assessment',
    subcategory: 'Patient Safety and Practice Assessment',
    weight: 'high',
    points: 20,
    supportingInfo: 'Participate in Maintenance of Certification (MOC) Part IV which requires clinicians to perform monthly activities across practice to regularly assess performance.',
    selected: false,
  },
  {
    activityId: 'IA_PSPA_3',
    activityDescription: 'Participate in IHI Training/Forum Event; National Academy of Medicine, AHRQ Team STEPPS® or Other Similar Activity',
    category: 'Patient Safety and Practice Assessment',
    subcategory: 'Patient Safety and Practice Assessment',
    weight: 'medium',
    points: 20,
    supportingInfo: 'For MIPS eligible clinicians not participating in MOC Part IV, new engagement such as IHI Training/Forum Event, National Academy of Medicine, or AHRQ Team STEPPS®.',
    selected: false,
  },
  {
    activityId: 'IA_PSPA_4',
    activityDescription: 'Administration of the AHRQ Survey of Patient Safety Culture',
    category: 'Patient Safety and Practice Assessment',
    subcategory: 'Patient Safety and Practice Assessment',
    weight: 'medium',
    points: 20,
    supportingInfo: 'Administration of the AHRQ Survey of Patient Safety Culture and submission of data to the comparative database. Note: This activity may be selected once every 4 years.',
    selected: false,
  },
  {
    activityId: 'IA_PSPA_7',
    activityDescription: 'Use of QCDR data for ongoing practice assessment and improvements',
    category: 'Patient Safety and Practice Assessment',
    subcategory: 'Patient Safety and Practice Assessment',
    weight: 'medium',
    points: 20,
    isMvpMeasure: true,
    supportingInfo: 'Participation in a Qualified Clinical Data Registry (QCDR) and use of QCDR data for ongoing practice assessment and improvements in patient safety.',
    selected: false,
  },
  {
    activityId: 'IA_PSPA_8',
    activityDescription: 'Use of Patient Safety Tools',
    category: 'Patient Safety and Practice Assessment',
    subcategory: 'Patient Safety and Practice Assessment',
    weight: 'medium',
    points: 20,
    supportingInfo: 'Use tools that assist specialty practices in tracking specific measures that are meaningful to their practice.',
    selected: false,
  },
  {
    activityId: 'IA_PSPA_9',
    activityDescription: 'Completion of the AMA STEPS Forward program',
    category: 'Patient Safety and Practice Assessment',
    subcategory: 'Patient Safety and Practice Assessment',
    weight: 'medium',
    points: 20,
    supportingInfo: 'Completion of the American Medical Association\'s STEPS Forward program.',
    selected: false,
  },
  {
    activityId: 'IA_PSPA_12',
    activityDescription: 'Participation in private payer CPIA',
    category: 'Patient Safety and Practice Assessment',
    subcategory: 'Patient Safety and Practice Assessment',
    weight: 'medium',
    points: 20,
    supportingInfo: 'Participation in designated private payer clinical practice improvement activities.',
    selected: false,
  },
  {
    activityId: 'IA_PSPA_13',
    activityDescription: 'Participation in Joint Commission Evaluation Initiative',
    category: 'Patient Safety and Practice Assessment',
    subcategory: 'Patient Safety and Practice Assessment',
    weight: 'medium',
    points: 20,
    supportingInfo: 'Participation in Joint Commission Ongoing Professional Practice Evaluation initiative.',
    selected: false,
  },
  {
    activityId: 'IA_PSPA_15',
    activityDescription: 'Implementation of an ASP',
    category: 'Patient Safety and Practice Assessment',
    subcategory: 'Patient Safety and Practice Assessment',
    weight: 'medium',
    points: 20,
    supportingInfo: 'Leadership of an Antimicrobial Stewardship Program (ASP) that includes implementation of an ASP that measures the appropriate use of antibiotics.',
    selected: false,
  },
  {
    activityId: 'IA_PSPA_16',
    activityDescription: 'Use decision support—ideally platform-agnostic, interoperable clinical decision support (CDS) tools —and standardized treatment protocols to manage workflow on the care team to meet patient needs',
    category: 'Patient Safety and Practice Assessment',
    subcategory: 'Patient Safety and Practice Assessment',
    weight: 'medium',
    points: 20,
    supportingInfo: 'Use decision support and standardized treatment protocols to manage workflow on the care team to meet patient needs.',
    selected: false,
  },
  {
    activityId: 'IA_PSPA_17',
    activityDescription: 'Implementation of analytic capabilities to manage total cost of care for practice population',
    category: 'Patient Safety and Practice Assessment',
    subcategory: 'Patient Safety and Practice Assessment',
    weight: 'medium',
    points: 20,
    supportingInfo: 'Conduct or build the capacity to conduct analytic activities to manage total cost of care for the practice population.',
    selected: false,
  },
  {
    activityId: 'IA_PSPA_18',
    activityDescription: 'Measurement and improvement at the practice and panel level',
    category: 'Patient Safety and Practice Assessment',
    subcategory: 'Patient Safety and Practice Assessment',
    weight: 'medium',
    points: 20,
    supportingInfo: 'Measure and improve quality at the practice and panel level, regularly reviewing measures of quality, utilization, patient satisfaction and other measures.',
    selected: false,
  },
  {
    activityId: 'IA_PSPA_19',
    activityDescription: 'Implementation of formal quality improvement methods, practice changes, or other practice improvement processes',
    category: 'Patient Safety and Practice Assessment',
    subcategory: 'Patient Safety and Practice Assessment',
    weight: 'medium',
    points: 20,
    supportingInfo: 'Adopt a formal model for quality improvement and create a culture in which all staff, including leadership, actively participates in improvement activities.',
    selected: false,
  },
  {
    activityId: 'IA_PSPA_21',
    activityDescription: 'Implementation of fall screening and assessment programs',
    category: 'Patient Safety and Practice Assessment',
    subcategory: 'Patient Safety and Practice Assessment',
    weight: 'medium',
    points: 20,
    supportingInfo: 'Implementation of fall screening and assessment programs to identify patients at risk for falls and address modifiable risk factors.',
    selected: false,
  },
  {
    activityId: 'IA_PSPA_22',
    activityDescription: 'CDC Training on CDC\'s Guideline for Prescribing Opioids for Chronic Pain',
    category: 'Patient Safety and Practice Assessment',
    subcategory: 'Patient Safety and Practice Assessment',
    weight: 'medium',
    points: 20,
    supportingInfo: 'Completion of all modules of the CDC course "Applying CDC\'s Guideline for Prescribing Opioids". Note: This activity may be selected once every 4 years.',
    selected: false,
  },
  {
    activityId: 'IA_PSPA_23',
    activityDescription: 'Completion of CDC Training on Antibiotic Stewardship',
    category: 'Patient Safety and Practice Assessment',
    subcategory: 'Patient Safety and Practice Assessment',
    weight: 'medium',
    points: 20,
    supportingInfo: 'Completion of all modules of the CDC antibiotic stewardship course. Note: This activity may be selected once every 4 years.',
    selected: false,
  },
  {
    activityId: 'IA_PSPA_25',
    activityDescription: 'Cost Display for Laboratory and Radiographic Orders',
    category: 'Patient Safety and Practice Assessment',
    subcategory: 'Patient Safety and Practice Assessment',
    weight: 'medium',
    points: 20,
    supportingInfo: 'Implementation of a cost display for laboratory and radiographic orders.',
    selected: false,
  },
  {
    activityId: 'IA_PSPA_26',
    activityDescription: 'Communication of Unscheduled Visit for Adverse Drug Event and Nature of Event',
    category: 'Patient Safety and Practice Assessment',
    subcategory: 'Patient Safety and Practice Assessment',
    weight: 'medium',
    points: 20,
    supportingInfo: 'A MIPS eligible clinician providing unscheduled care attests that for greater than 75 percent of case visits from a clinically significant adverse drug event, provides information to the patient\'s primary care clinician within 48 hours.',
    selected: false,
  },
  {
    activityId: 'IA_PSPA_28',
    activityDescription: 'Completion of an Accredited Safety or Quality Improvement Program',
    category: 'Patient Safety and Practice Assessment',
    subcategory: 'Patient Safety and Practice Assessment',
    weight: 'medium',
    points: 20,
    supportingInfo: 'Completion of an accredited performance improvement continuing medical education (CME) program that addresses performance or quality improvement.',
    selected: false,
  },
  {
    activityId: 'IA_PSPA_31',
    activityDescription: 'Patient Medication Risk Education',
    category: 'Patient Safety and Practice Assessment',
    subcategory: 'Patient Safety and Practice Assessment',
    weight: 'medium',
    points: 20,
    supportingInfo: 'Provide both written and verbal education regarding the risks of concurrent opioid and benzodiazepine use for at least 75% of qualifying patients.',
    selected: false,
  },
  {
    activityId: 'IA_PSPA_32',
    activityDescription: 'Use of CDC Guideline for Clinical Decision Support to Prescribe Opioids for Chronic Pain via Clinical Decision Support',
    category: 'Patient Safety and Practice Assessment',
    subcategory: 'Patient Safety and Practice Assessment',
    weight: 'medium',
    points: 20,
    supportingInfo: 'Utilize the CDC Guideline for Prescribing Opioids for Chronic Pain via clinical decision support (CDS) built directly into the clinician workflow.',
    selected: false,
  },
  {
    activityId: 'IA_PSPA_33',
    activityDescription: 'Application of CDC\'s Training for Healthcare Providers on Lyme Disease',
    category: 'Patient Safety and Practice Assessment',
    subcategory: 'Patient Safety and Practice Assessment',
    weight: 'medium',
    points: 20,
    supportingInfo: 'Apply the CDC\'s Training for Healthcare Providers on Lyme Disease using clinical decision support (CDS) built directly into the clinician workflow.',
    selected: false,
  },
    {
    activityId: 'IA_PSPA_34',
    activityDescription: 'Patient Safety in Use of Artificial Intelligence (AI)',
    category: 'Patient Safety and Practice Assessment',
    subcategory: 'Patient Safety and Practice Assessment',
    weight: 'medium',
    points: 20,
    supportingInfo: 'Establish policies and procedures to ensure safe and appropriate use of artificial intelligence tools in clinical decision-making, including clinician oversight mechanisms and staff training on AI limitations.',
    selected: false,
  },
  {
    activityId: 'IA_PSPA_35',
    activityDescription: 'Adopt Certified Health Information Technology for Security Tags for Electronic Health Record Data',
    category: 'Patient Safety and Practice Assessment',
    subcategory: 'Patient Safety and Practice Assessment',
    weight: 'medium',
    points: 20,
    supportingInfo: 'Use security labeling services available in certified Health Information Technology (IT) for electronic health record (EHR) data to facilitate data segmentation.',
    selected: false,
  },


  // Advancing Health and Wellness
  {
    activityId: 'IA_AHW_1',
    activityDescription: 'Chronic Care and Preventative Care Management for Empaneled Patients',
    category: 'Advancing Health and Wellness',
    subcategory: 'Advancing Health and Wellness',
    weight: 'medium',
    points: 20,
    supportingInfo: 'Manage chronic and preventive care for empaneled patients, including providing patients annually with an opportunity for development of an individualized plan of care.',
    selected: false,
  },

  // Emergency Response And Preparedness
  {
    activityId: 'IA_ERP_1',
    activityDescription: 'Participation on Disaster Medical Assistance Team, registered for 6 months',
    category: 'Emergency Response And Preparedness',
    subcategory: 'Emergency Response And Preparedness',
    weight: 'medium',
    points: 20,
    supportingInfo: 'Participation in Disaster Medical Assistance Teams or Community Emergency Responder Teams. MIPS eligible clinicians must be registered for a minimum of 6 months as a volunteer.',
    selected: false,
  },
  {
    activityId: 'IA_ERP_2',
    activityDescription: 'Participation in a 60-day or greater effort to support domestic or international humanitarian needs',
    category: 'Emergency Response And Preparedness',
    subcategory: 'Emergency Response And Preparedness',
    weight: 'medium',
    points: 20,
    supportingInfo: 'Participation in domestic or international humanitarian volunteer work for a period of a continuous 60 days or greater.',
    selected: false,
  },

  // Behavioral And Mental Health
  {
    activityId: 'IA_BMH_1',
    activityDescription: 'Antipsychotic-Medication-Associated Physical Health Condition Assessment and Monitoring',
    category: 'Behavioral And Mental Health',
    subcategory: 'Behavioral And Mental Health',
    weight: 'medium',
    points: 20,
    supportingInfo: 'Diabetes screening for people with schizophrenia or bipolar disease who are using antipsychotic medication.',
    selected: false,
  },
  {
    activityId: 'IA_BMH_2',
    activityDescription: 'Tobacco use',
    category: 'Behavioral And Mental Health',
    subcategory: 'Behavioral And Mental Health',
    weight: 'medium',
    points: 20,
    supportingInfo: 'Regular engagement in integrated prevention and treatment interventions, including tobacco use screening and cessation interventions for patients with co-occurring behavioral or mental health conditions.',
    selected: false,
  },
  {
    activityId: 'IA_BMH_4',
    activityDescription: 'Depression screening',
    category: 'Behavioral And Mental Health',
    subcategory: 'Behavioral And Mental Health',
    weight: 'medium',
    points: 20,
    supportingInfo: 'Regular engagement in integrated prevention and treatment interventions, including depression screening and follow-up plan for patients with co-occurring behavioral or mental health conditions.',
    selected: false,
  },
  {
    activityId: 'IA_BMH_5',
    activityDescription: 'MDD prevention and treatment interventions',
    category: 'Behavioral And Mental Health',
    subcategory: 'Behavioral And Mental Health',
    weight: 'medium',
    points: 20,
    supportingInfo: 'Regular engagement in integrated prevention and treatment interventions, including suicide risk assessment for mental health patients with co-occurring conditions.',
    selected: false,
  },
  {
    activityId: 'IA_BMH_7',
    activityDescription: 'Implementation of Integrated Patient Centered Behavioral Health Model',
    category: 'Behavioral And Mental Health',
    subcategory: 'Behavioral And Mental Health',
    weight: 'medium',
    points: 20,
    supportingInfo: 'Offer integrated behavioral health services to support patients with behavioral health needs who also have conditions such as dementia or other poorly controlled chronic illnesses.',
    selected: false,
  },
  {
    activityId: 'IA_BMH_9',
    activityDescription: 'Unhealthy Alcohol Use for Patients with Co-occurring Conditions of Mental Health and Substance Abuse and Ambulatory Care Patients',
    category: 'Behavioral And Mental Health',
    subcategory: 'Behavioral And Mental Health',
    weight: 'medium',
    points: 20,
    supportingInfo: 'Regularly engage in integrated prevention and treatment interventions, including screening and brief counseling for patients with co-occurring conditions of mental health and substance abuse.',
    selected: false,
  },
  {
    activityId: 'IA_BMH_10',
    activityDescription: 'Completion of Collaborative Care Management Training Program',
    category: 'Behavioral And Mental Health',
    subcategory: 'Behavioral And Mental Health',
    weight: 'medium',
    points: 20,
    supportingInfo: 'Complete a collaborative care management training program to implement a collaborative care management approach that integrates behavioral health into primary care practice.',
    selected: false,
  },
  {
    activityId: 'IA_BMH_11',
    activityDescription: 'Implementation of a Trauma-Informed Care (TIC) Approach to Clinical Practice',
    category: 'Behavioral And Mental Health',
    subcategory: 'Behavioral And Mental Health',
    weight: 'medium',
    points: 20,
    supportingInfo: 'Create and implement a plan for trauma-informed care (TIC) that recognizes the potential impact of trauma experiences on patients.',
    selected: false,
  },
  {
    activityId: 'IA_BMH_12',
    activityDescription: 'Promoting Clinician Well-Being',
    category: 'Behavioral And Mental Health',
    subcategory: 'Behavioral And Mental Health',
    weight: 'medium',
    points: 20,
    supportingInfo: 'Develop and implement programs to support clinician well-being and resilience through relationship-building opportunities or leadership development plans.',
    selected: false,
  },
  {
    activityId: 'IA_BMH_14',
    activityDescription: 'Behavioral/Mental Health and Substance Use Screening & Referral for Pregnant and Postpartum Women',
    category: 'Behavioral And Mental Health',
    subcategory: 'Behavioral And Mental Health',
    weight: 'medium',
    points: 20,
    supportingInfo: 'Screen for perinatal mood and anxiety disorders (PMADs) and substance use disorder (SUD) in pregnant and postpartum women.',
    selected: false,
  },
  {
    activityId: 'IA_BMH_15',
    activityDescription: 'Behavioral/Mental Health and Substance Use Screening & Referral for Older Adults',
    category: 'Behavioral And Mental Health',
    subcategory: 'Behavioral And Mental Health',
    weight: 'medium',
    points: 20,
    supportingInfo: 'Complete age-appropriate screening for mental health and substance use in older adults.',
    selected: false,
  },

  // MIPS Value Pathways
  {
    activityId: 'IA_MVP',
    activityDescription: 'Practice-Wide Quality Improvement in MIPS Value Pathways',
    category: 'MIPS Value Pathways',
    subcategory: 'MIPS Value Pathways',
    weight: 'medium',
    points: 20,
    isMvpMeasure: true,
    supportingInfo: 'Create a quality improvement initiative within your practice that involves a minimum of three of the measures within a specific MVP. Requires participation in MVPs.',
    selected: false,
  },
  {
    activityId: 'IA_PCMH',
    activityDescription: 'Electronic submission of Patient Centered Medical Home accreditation',
    category: 'Patient Centered Medical Home',
    subcategory: 'Patient Centered Medical Home',
    weight: 'high',
    points: 40,
    isMvpMeasure: true,
    supportingInfo: 'I attest that I am a Patient Centered Medical Home (PCMH) or Comparable Specialty Practice that has been recognized/accredited by a national or State agency. This activity gives full credit (40 points) regardless of special status.',
    selected: false,
  },
];

export const IA_CATEGORY_ORDER_2025: string[] = [
  'Expanded Practice Access',
  'Population Management',
  'Care Coordination',
  'Beneficiary Engagement',
  'Patient Safety and Practice Assessment',
  'Achieving Health Equity',
  'Emergency Response And Preparedness',
  'Behavioral And Mental Health',
  'MIPS Value Pathways',
];

export const IA_CATEGORY_ORDER_2026: string[] = [
  'Expanded Practice Access',
  'Population Management',
  'Care Coordination',
  'Beneficiary Engagement',
  'Patient Safety and Practice Assessment',
  'Advancing Health and Wellness',
  'Emergency Response And Preparedness',
  'Behavioral And Mental Health',
  'Patient Centered Medical Home',
  'MIPS Value Pathways',
];
